
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.919.415L3.75.75H1.5a.75.75 0 100 1.5h9a.75.75 0 100-1.5H8.25L8.081.415A.747.747 0 007.411 0H4.589a.747.747 0 00-.67.415zM10.5 3h-9l.497 7.945c.037.593.53 1.055 1.123 1.055h5.76c.593 0 1.086-.462 1.123-1.055L10.5 3z","fill":"red"}})])
          )
        }
      }
    